/**
 * The query keys the reads in this folder are cached under.
 *
 * Analytics is read-only — nothing in the app writes a result back — so there
 * is no `analytics-cache` beside this file. The keys still live apart from the
 * queries themselves so that anything which later needs to invalidate them can
 * reach them without importing a query module and closing an import cycle.
 */

// The tasks-and-alerts timeseries every chart on the reports page is derived
// from.
export const FETCH_TASKS_AND_ALERTS_QUERY_KEY = 'fetchTasksAndAlertsAnalytics';

// Tasks and alerts totalled per team.
export const FETCH_TEAM_ACTIVITY_QUERY_KEY = 'fetchTeamActivityAnalytics';

// Tasks and alerts totalled per user.
export const FETCH_USER_ACTIVITY_QUERY_KEY = 'fetchUserActivityAnalytics';

// Tasks and alerts bucketed by hour of the week.
export const FETCH_HOURLY_ACTIVITY_QUERY_KEY =
    'fetchTasksAndAlertsHourlyActivity';

// The location points behind the heatmap, paged over until exhausted.
export const FETCH_LOCATION_ANALYTICS_QUERY_KEY = 'fetchLocationAnalytics';
